import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=0f44fd0a&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/wbcre8/projects/regista/nwo17/wp-content/themes/keni8_child/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f44fd0a')) {
      api.createRecord('0f44fd0a', component.options)
    } else {
      api.reload('0f44fd0a', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=0f44fd0a&", function () {
      api.rerender('0f44fd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/loader.vue"
export default component.exports